import { Stack, Typography, useTheme } from "@mui/material";
import { Check } from "lucide-react";
import type { FC } from "react";
import { IconBox } from "web_myplann/Shared/Components/IconBox";

type Props = {
	title: string;
	description: string;
};

export const ContactAgentDialogSuccessStep: FC<Props> = ({
	title,
	description,
}) => {
	const theme = useTheme();

	return (
		<Stack alignItems="center" textAlign="center">
			<IconBox bg={theme.palette.green[100]} shape="circle" size={48}>
				<Check
					size={theme.iconSize.lg}
					color={theme.palette.green[600]}
					aria-hidden
				/>
			</IconBox>
			<Typography variant="h3" component="h2" mt={theme.spacingTokens.lg}>
				{title}
			</Typography>
			<Typography variant="body2" mt={theme.spacingTokens.sm}>
				{description}
			</Typography>
		</Stack>
	);
};
